module.exports = __webpack_public_path__ + "static/img/logo-marianne-anfr.28cb8da.svg";